// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2FF0i","label":"SetPasswdForm_label__3637P"};